import { localFlags } from './flags'

export const alertError = async (context: string, object?: any) => {
  if (localFlags.alertError) {
    if (object) {
      alert(`[${context}] ${JSON.stringify(object)}`)
    } else {
      alert(`[${context}]`)
    }
  }
}
